import { render, staticRenderFns } from "./GameView.vue?vue&type=template&id=6c0b0d29&scoped=true&"
import script from "./GameView.vue?vue&type=script&lang=js&"
export * from "./GameView.vue?vue&type=script&lang=js&"
import style0 from "./GameView.vue?vue&type=style&index=0&id=6c0b0d29&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0b0d29",
  null
  
)

component.options.__file = "GameView.vue"
export default component.exports